import {
  Card,
  CardActionArea,
  CardActions,
  CardContent,
  Chip,
  Link,
  Stack,
  Typography
} from '@mui/material'
import React from 'react'
import PropTypes from 'prop-types'
import { Link as RouterLink } from 'react-router-dom'
import { DateTime } from 'luxon'
import UploadCardMedia from './UploadCardMedia'
import ShareButton from './ShareButton'
import ViewButton from './ViewButton'
import Delimeter from '../common/Delimeter'

HighlightPreviewCard.propTypes = {
  highlight: PropTypes.object
}

export default function HighlightPreviewCard ({ highlight }) {
  return (
    <Card sx={{ height: '100%', display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
      <CardActionArea
        component={RouterLink}
        to={`/upload/${highlight.upload.id}/highlight/${highlight.id}`}
        sx={{ flexGrow: 1, alignItems: 'stretch' }}
      >
        <UploadCardMedia upload={highlight.upload} height={190} />
        <CardContent sx={{ p: { xs: 1.5, sm: 2 } }}>
          <Typography
            variant="h6"
            component="div"
            sx={{
              fontWeight: 700,
              lineHeight: 1.25,
              display: '-webkit-box',
              WebkitLineClamp: 2,
              WebkitBoxOrient: 'vertical',
              overflow: 'hidden'
            }}
          >
            {highlight.name}
          </Typography>
          {highlight.origin === 'ai' && <Chip size="small" color="warning" variant="outlined" label="AI · beta" sx={{ mt: 0.75 }} />}

          {highlight.description
            ? <Typography
                variant="body2"
                color="text.secondary"
                sx={{
                  mt: 0.75,
                  display: '-webkit-box',
                  WebkitLineClamp: 2,
                  WebkitBoxOrient: 'vertical',
                  overflow: 'hidden'
                }}
              >
                {highlight.description}
              </Typography>
            : null}

          <Stack spacing={0.4} sx={{ mt: 1.25 }}>
            <Typography variant="body2" color="text.secondary">
              Upload:{' '}
              <Link
                component={RouterLink}
                to={`/upload/${highlight.upload.id}`}
                onClick={event => event.stopPropagation()}
              >
                {highlight.upload.name}
              </Link>
            </Typography>
            {highlight.owner
              ? <Typography variant="body2" color="text.secondary">
                  Author: {highlight.owner}
                </Typography>
              : null}
            {highlight.groups && highlight.groups.length
              ? <Typography variant="body2" color="text.secondary">
                  Groups: <Delimeter values={highlight.groups} />
                </Typography>
              : null}
          </Stack>

          {highlight.tags.items.length
            ? <Stack direction="row" spacing={0.5} useFlexGap flexWrap="wrap" sx={{ mt: 1.25 }}>
                {highlight.tags.items.slice(0, 6).map(tag => (
                  <Chip
                    key={tag.id}
                    label={tag.name}
                    component={RouterLink}
                    to={`/?tag=${encodeURIComponent(tag.name)}`}
                    onClick={event => event.stopPropagation()}
                    clickable
                    variant="outlined"
                    size="small"
                  />
                ))}
                {highlight.tags.items.length > 6
                  ? <Chip label={`+${highlight.tags.items.length - 6}`} size="small" variant="outlined" />
                  : null}
              </Stack>
            : null}

          <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 1.25 }}>
            {DateTime.fromISO(highlight.createdAt).toLocaleString(DateTime.DATETIME_MED)}
          </Typography>
        </CardContent>
      </CardActionArea>

      <CardActions sx={{ px: 1.5, pb: 1.5, pt: 0, mt: 'auto' }}>
        <ViewButton url={`/upload/${highlight.uploadHighlightsId}/highlight/${highlight.id}`} />
        <ShareButton url={`/upload/${highlight.uploadHighlightsId}/highlight/${highlight.id}`} />
      </CardActions>
    </Card>
  )
}
